import {POST_FCM_SEND_CSV_START} from "../../types";

export const fcm_send_csv = (payload) => ({
  type: POST_FCM_SEND_CSV_START,
  payload,
});
